// import Swiper JS
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation, Pagination]);

export function initBrandLogoCarousel() {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=brand-logo-carousel',
      brandLogoCarousel
    );
  }
}

export function brandLogoCarousel() {
  if (!document.querySelector('.brand-logo-carousel')) return;

  let swiperContainer = document.querySelector(
    '.brand-logo-carousel > .swiper'
  );

  let mobileSlides = Number(swiperContainer.dataset.slidesPerViewMobile);
  let tabletSlides = Number(swiperContainer.dataset.slidesPerViewTablet);
  let laptopSlides = Number(swiperContainer.dataset.slidesPerViewLaptop);
  let desktopSlides = Number(swiperContainer.dataset.slidesPerViewDesktop);
  let showPagination = Number(swiperContainer.dataset.showPagination);
  let hideNavigation = Number(swiperContainer.dataset.hideNavigation);

  const params = {
    // Optional parameters
    slidesPerView: mobileSlides,
    slidesPerGroup: mobileSlides,
    spaceBetween: 80,
    breakpoints: {
      769: {
        slidesPerView: tabletSlides,
        slidesPerGroup: tabletSlides,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: laptopSlides,
        slidesPerGroup: laptopSlides,
        spaceBetween: 20,
      },
      1441: {
        slidesPerView: desktopSlides,
        slidesPerGroup: desktopSlides,
        spaceBetween: 20,
      },
    },
  };

  if (showPagination) {
    params.pagination = {
      el: '.brand-logo-carousel-pagination',
    };
  }

  if (hideNavigation != 1) {
    params.navigation = {
      nextEl: '.brand-logo-carousel-next',
      prevEl: '.brand-logo-carousel-prev',
    };
  }
  // console.log(
  //   '🚀 ~ file: brand-logo-carousel.js:55 ~ brandLogoCarousel ~ params:',
  //   params
  // );

  const brandLogoCarousel = new Swiper('.brand-logo-carousel > .swiper', {
    ...params,
    autoplay: {
      delay: 3000,
    },
    loop: false,
  });
}
